import { useMemo } from 'react';

import { QueryRefetchInterval } from '@cast/shared-types';
import { OmniCluster } from '@cast/types-omni';

import { useListOmniClustersQuery } from 'hooks/queries/omni';

import { findOmniClusterInList } from '../utils';

export const useGetOmniClusterFromList = ({
  clusterId,
  refetchInterval,
  enabled = true,
}: {
  clusterId: string;
  refetchInterval?: QueryRefetchInterval<OmniCluster[]>;
  enabled?: boolean;
}) => {
  const { data, isLoading, error, refetch } = useListOmniClustersQuery({
    enabled: enabled && !!clusterId,
    refetchInterval,
  });

  const clusterDetails = useMemo(() => {
    if (!data) {
      return null;
    }

    return findOmniClusterInList(clusterId, data);
  }, [data, clusterId]);

  return {
    clusterDetails,
    isLoading,
    error,
    refetch,
  };
};
